import Alpine from 'alpinejs';
import './styles/main.scss';
import { initParallax } from './parallax.js';

// Alpine component: registration form
Alpine.data('registrationForm', () => ({
  name: '',
  email: '',
  phone: '',
  message: '',
  website: '',
  submitted: false,
  submitting: false,
  error: '',
  async submit() {
    this.error = '';
    this.submitting = true;

    try {
      const res = await fetch('/api/register.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message,
          website: this.website,
        }),
      });

      let data = {};
      try { data = await res.json(); } catch { /* non-JSON response */ }

      if (!res.ok) {
        this.error = data.error || 'Něco se pokazilo, zkuste to později.';
        return;
      }

      this.submitted = true;
    } catch {
      this.error = 'Nepodařilo se spojit se serverem, zkuste to později.';
    } finally {
      this.submitting = false;
    }
  },
}));

window.Alpine = Alpine;
Alpine.start();

initParallax();
